import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  ContentLookup,
  SuccessResponse,
  X1Language,
  X2AgeCategory,
  X2AgeCategoryUpdateModel
} from '../../../../domain';
import {Control, HttpPromiseState, SaveStateHolder, validators} from '../../../../lib/helpers';

export class MoveAgeCategoryStore implements SaveStateHolder {
  language: Control<X1Language | null>;

  readonly languageOptions: readonly X1Language[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly ageCategory: X2AgeCategory,
              readonly lookup: ContentLookup) {
    makeObservable(this);
    this.language = new Control<X1Language | null>(
      'LanguageId',
      ageCategory.Language,
      validators.required
    );
    this.languageOptions = lookup.Languages;

    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.language.markTouched();
    if (this.language.invalid)
      return;

    const model: X2AgeCategoryUpdateModel = {
      LanguageId: this.language.value!.Id,
      Name: this.ageCategory.Name
    };
    this.save = contentLoaders.x2ageCategory.update(this.ageCategory.Id, model);
  }
}
